/* Ecochic · EcoStore — capa de datos de la cuenta (perfil, rutina, diario, hábito, club, evolución, fotos).
   Decisión 01-10: la cuenta es la de Shopify (para guardar hay que iniciar sesión). Los datos se guardan
   de momento EN ESTE DISPOSITIVO, ligados al cliente; más adelante el backend será Supabase.

   Cómo funciona
   - Los módulos de la lógica leen y escriben sus claves de siempre en localStorage (eco_profile, eco_routine…):
     son la «copia de trabajo».
   - Al cargar: sin sesión, la copia de trabajo se vacía (nadie hereda datos de otro). Con sesión, se rellena
     con los datos de ese cliente (backend.pull) y eco_account sale del cliente de Shopify.
   - Al cambiar algo (se compara cada 2 s, al ocultar la página y al salir) se guarda todo el conjunto del
     cliente (backend.push). Borrar una clave (p. ej. «Borrar mi perfil») también se guarda.

   Contrato del backend (para cambiar a Supabase sin tocar las páginas):
     { name, pull(uid) -> objeto {clave: texto} | Promise, push(uid, objeto) -> void | Promise }
   EcoStore.setBackend(impl) lo cambia. Con un backend remoto, la copia de trabajo hace de caché: se pinta
   al momento y, cuando llega pull(), se reescribe y se avisa con el evento «eco:store-ready».
   Fotos: IndexedDB propia de cada cliente (EcoStore.mediaDB()). */
(function () {
  'use strict';
  var SES = window.ECO_SESSION || {}, C = SES.customer || null, UID = C ? String(C.id) : null;
  var KEYS = ['eco_profile', 'eco_perso', 'eco_routine', 'eco_inuse', 'eco_diary', 'eco_habit', 'eco_club', 'eco_skin_history', 'eco_consent', 'eco_account'];
  var SAVED = ['eco_profile', 'eco_perso', 'eco_routine', 'eco_inuse', 'eco_diary', 'eco_habit', 'eco_club', 'eco_skin_history', 'eco_consent']; // eco_account sale de Shopify
  // C391: claves que solo viajan con permiso vigente (EcoConsent, eco-consent.js); el registro eco_consent viaja siempre
  var NEEDS = { eco_profile: 'perfil_piel', eco_perso: 'perfil_piel', eco_routine: 'perfil_piel', eco_skin_history: 'perfil_piel', eco_diary: 'diario', eco_inuse: 'diario' };
  function ls() { try { return window.localStorage; } catch (e) { return null; } }
  var L = ls();
  function get(k) { try { return L ? L.getItem(k) : null; } catch (e) { return null; } }
  function put(k, v) { try { if (!L) return; if (v == null) L.removeItem(k); else L.setItem(k, v); } catch (e) {} }

  /* backend local: un bloque por cliente en este dispositivo */
  var localBackend = {
    name: 'local',
    pull: function (uid) { try { return JSON.parse(get('eco:u:' + uid) || '{}') || {}; } catch (e) { return {}; } },
    push: function (uid, obj) { put('eco:u:' + uid, JSON.stringify(obj)); }
  };
  /* backend «supabase»: el app proxy de Shopify (/apps/ecochic/data) llega a una Edge Function de Supabase.
     Shopify añade a cada petición el ID del cliente con sesión y la firma (HMAC); la función la comprueba,
     así el navegador no maneja ningún token. La copia local sigue haciendo de caché. */
  function proxyBackend(path) {
    return {
      name: 'supabase', remote: true,
      pull: function (uid) {
        return fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('proxy ' + r.status); return r.json(); })
          .then(function (j) { return (j && j.customer_id === uid && j.data) || {}; });
      },
      push: function (uid, obj) {
        return fetch(path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_id: uid, data: obj }) })
          .then(function (r) { if (!r.ok) throw new Error('proxy ' + r.status); });
      }
    };
  }
  var backend = (SES.backend === 'supabase' && SES.proxyPath) ? proxyBackend(SES.proxyPath) : localBackend;

  function allowed(k) { return !NEEDS[k] || !!(window.EcoConsent && EcoConsent.has(NEEDS[k])); }
  // segunda barrera (C391): sin permiso, esas claves no se envían al almacén del cliente aunque un módulo las haya escrito
  function snapshot() { var o = {}; SAVED.forEach(function (k) { var v = get(k); if (v != null && allowed(k)) o[k] = v; }); return o; }
  function fill(obj) { SAVED.forEach(function (k) { put(k, obj && obj[k] != null ? obj[k] : null); }); }
  var last = '';
  function flush() {
    if (!UID || !window.EcoConsent) return; // sin el módulo de permisos no se envía nada (ni se borra nada del almacén)
    var s = snapshot(), j = JSON.stringify(s);
    if (j === last) return;
    last = j;
    if (backend.remote) localBackend.push(UID, s); // caché en el dispositivo
    try { var r = backend.push(UID, s); if (r && r.catch) r.catch(function () { last = ''; }); } catch (e) { last = ''; }
  }
  function hydrate(obj) { fill(obj || {}); last = window.EcoConsent ? JSON.stringify(snapshot()) : ''; }

  // 1) copia de trabajo de quien corresponde
  if (!UID) { KEYS.forEach(function (k) { put(k, null); }); put('eco_owner', null); }
  else {
    if (get('eco_owner') !== UID) KEYS.forEach(function (k) { put(k, null); });
    put('eco_owner', UID);
    if (backend.remote) {
      // se pinta al momento con la caché y, cuando responde el servidor, se reescribe y se avisa
      hydrate(localBackend.pull(UID));
      backend.pull(UID).then(function (o) { hydrate(o); localBackend.push(UID, snapshot()); document.dispatchEvent(new CustomEvent('eco:store-ready')); }, function () {});
    } else hydrate(backend.pull(UID));
    put('eco_account', JSON.stringify({ name: C.name || '', email: C.email || '' }));
    setInterval(flush, 2000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
    window.addEventListener('pagehide', flush);
  }

  // 2) sin sesión, toda acción que guarda lleva a iniciar sesión y vuelve a la misma página
  var SEL = '.eco-rt-btn, [data-saveall], [data-saveone], [data-eq-save], [data-eco-save], [data-eco-diary]';
  function loginUrl() {
    var u = SES.loginUrl || '/account/login', back = encodeURIComponent(location.pathname + location.search);
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'return_url=' + back + '&return_to=' + back;
  }
  if (!UID) document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(SEL); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    // quien tenga algo a medias (p. ej. el diagnóstico) lo aparta antes de ir a iniciar sesión
    try { document.dispatchEvent(new CustomEvent('eco:login-needed', { detail: { el: b } })); } catch (x) {}
    location.href = loginUrl();
  }, true);

  window.EcoStore = {
    backend: function () { return backend.name; },
    setBackend: function (impl) { if (impl && impl.pull && impl.push) backend = impl; },
    user: function () { return C; },
    signedIn: function () { return !!UID; },
    flush: flush,
    snapshot: snapshot,
    loginUrl: loginUrl,
    // cerrar sesión: guarda, vacía este dispositivo y cierra la sesión de Shopify
    logout: function () { flush(); KEYS.forEach(function (k) { put(k, null); }); put('eco_owner', null); location.href = SES.logoutUrl || '/'; },
    mediaDB: function () { return UID ? 'eco_media_' + UID : null; }
  };
})();
